import { NavItemProps } from "./NavItem";

export const NAV_ROUTES: NavItemProps[] = [
  { to: "/#features", children: "Tính năng" },
  { to: "/#portfolio", children: "Sản phẩm" },
  { to: "/#products", children: "Giá" },
  { to: "/#testimonials", children: "Khách hàng" },
  { to: "/#team", children: "Đội ngũ nhân sự" },
];



// WEBPACK FOOTER //
// ./src/layouts/Main/constants.ts